"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _web = require("@react-spring/web");
var _polished = require("polished");
var _icons = require("../../icons");
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
var _styles = require("../../../shared/styles");
var _selectors = require("../../../shared/styles/themes/selectors");
var _omitProps = _interopRequireDefault(require("../../../omitProps"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = (0, _styledComponents["default"])((0, _omitProps["default"])(_web.animated.div, ['isOpen', 'colorType']))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: ", ";\n"])), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'auto' : 'none';
});
var Nav = (0, _styledComponents["default"])((0, _omitProps["default"])(_web.animated.nav, ['colorType']))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 300px;\n  height: 100%;\n  background: ", ";\n  color: ", ";\n  top: 0;\n  ", "\n  ", "\n  ", "\n  z-index: 31;\n  padding-top: 60px;\n  ", ";\n  "])), function (props) {
  return (0, _selectors.sidebarBackground)(props);
}, function (props) {
  return (0, _selectors.sidebarColor)(props);
}, function (_ref2) {
  var position = _ref2.position;
  return "".concat(position, ": 0;");
}, (0, _styles.padding)(), (0, _styles.fontSize)('xs'), _styles.media.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-top: 75px;\n  "]))));
var CloseButton = (0, _styledComponents["default"])(_icons.MenuOpen)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  z-index: 10;\n  cursor: pointer;\n  ", "\n  ", "\n"])), function (_ref3) {
  var position = _ref3.position;
  return "".concat(position, ": 0;");
}, (0, _styles.margin)('s'));
var LinksWrap = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  overflow-y: scroll;\n  height: 100%;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"])));
var Overlay = (0, _styledComponents["default"])(_web.animated.div)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  width: 100%;\n  height: 100%;\n  z-index: 30;\n  pointer-events: none;\n"])), (0, _polished.transparentize)(0.2, _styles.color.darkBlue));
var Menu = function Menu(_ref4) {
  var isOpen = _ref4.isOpen,
    _ref4$position = _ref4.position,
    position = _ref4$position === void 0 ? 'right' : _ref4$position,
    onClose = _ref4.onClose,
    _ref4$closeOnOusideCl = _ref4.closeOnOusideClick,
    closeOnOusideClick = _ref4$closeOnOusideCl === void 0 ? true : _ref4$closeOnOusideCl,
    _ref4$closeButton = _ref4.closeButton,
    closeButton = _ref4$closeButton === void 0 ? true : _ref4$closeButton,
    children = _ref4.children,
    colorType = _ref4.colorType;
  var animation = (0, _web.useSpring)({
    transform: isOpen ? 'translateX(0%)' : 'translateX(100%)'
  });
  var overlayAnimation = (0, _web.useSpring)({
    opacity: isOpen ? 1 : 0,
    pointerEvents: isOpen ? 'auto' : 'none'
  });
  var close = function close() {
    if (isOpen && (0, _isFunction["default"])(onClose)) {
      onClose();
    }
  };
  var handleClickOverlay = function handleClickOverlay() {
    if (closeOnOusideClick && isOpen) {
      close();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    isOpen: isOpen,
    colorType: colorType
  }, /*#__PURE__*/_react["default"].createElement(Overlay, {
    style: overlayAnimation,
    onClick: handleClickOverlay
  }), /*#__PURE__*/_react["default"].createElement(Nav, {
    style: animation,
    position: position,
    colorType: colorType
  }, closeButton && /*#__PURE__*/_react["default"].createElement(CloseButton, {
    position: position,
    onClick: close
  }), /*#__PURE__*/_react["default"].createElement(LinksWrap, null, children)));
};
Menu.propTypes = {
  colorType: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  isOpen: _propTypes["default"].bool,
  closeButton: _propTypes["default"].bool,
  position: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  closeOnOusideClick: _propTypes["default"].bool
};
var Sidebar = /*#__PURE__*/function (_Component) {
  function Sidebar() {
    _classCallCheck(this, Sidebar);
    return _callSuper(this, Sidebar, arguments);
  }
  _inherits(Sidebar, _Component);
  return _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Menu, this.props);
    }
  }]);
}(_react.Component);
_defineProperty(Sidebar, "Item", _MenuItem["default"]);
var _default = exports["default"] = Sidebar;